import { find, findAll } from "../utils/dom";
import Swiper from "swiper";

const PageAtividadesEducativas = () =>{
	const page = find(`[js-page='atividades-educativas']`);
	if(!page) return;


	const $MobileCardsOficinas = {
		cards: findAll("[js-info-mobile-oficinas]"),
		buttonFechar: findAll("[js-bt-closed-info-mobile-oficinas]"),
		buttonAbrir: findAll("[js-bt-open-info-mobile-oficinas]")
	}

	$MobileCardsOficinas.buttonAbrir?.forEach((bt)=>{
		bt.addEventListener("click", (e)=>{
			const idCard = e.target.getAttribute('js-bt-open-info-mobile-oficinas');
			if(!idCard) return;

			find(`[js-info-mobile-oficinas='${idCard}']`).classList.add("active");
		})
	});

	$MobileCardsOficinas.buttonFechar?.forEach((bt)=>{
		bt.addEventListener("click", (e)=>{
			const idCard = e.target.getAttribute('js-bt-closed-info-mobile-oficinas');
			if(!idCard) return;

			find(`[js-info-mobile-oficinas='${idCard}']`).classList.remove("active");
		})
	});



	const $modal = {
		modais: findAll("[js-modal]")
	}
	const $modalValuesTarget = {
		titulo: find("[js-modal-alvo-titulo]"),
		duracao: find("[js-modal-alvo-duracao]"),
		classificacao: find("[js-modal-alvo-classificacao]"),
		sinopse: find("[js-modal-alvo-sinopse]")
	}


	$modal.modais?.forEach((modal)=>{
		modal.addEventListener("click", (e)=>{
			
			console.log(e.target.getAttribute('js-modal'))
			if(e.target.classList.contains('active') || e.target.getAttribute('js-modal') == null) return;

			const $modalValues = {
				titulo: e.target.getAttribute('js-modal-titulo'),
				duracao: e.target.getAttribute('js-modal-duracao'),
				classificacao: e.target.getAttribute('js-modal-classificacao'),
				sinopse: e.target.getAttribute('js-modal-sinopse')
			}

			$modalValuesTarget.titulo.innerText = `${$modalValues.titulo}`;
			$modalValuesTarget.duracao.innerText = `${$modalValues.duracao}`;
			$modalValuesTarget.classificacao.innerText = `${$modalValues.classificacao}`;
			$modalValuesTarget.sinopse.innerText = `${$modalValues.sinopse}`;

		})
	})



	const SwiperEventos = new Swiper(".swiper-eventos",{
		spaceBetween: 16,
		slidesPerView: 1,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		pagination: {
			clickable: true,
			el: ".swiper-pagination",
			dynamicBullets: true,
		},
		breakpoints:{
			767:{
				slidesPerView: 2,
				pagination:{
					dynamicBullets: false,
				}
			}
		}
	})

}

export default PageAtividadesEducativas;